import CustomerProjectTypesStatusesFlow from '../../CustomerProjectFlow'

const CustomerOpportunitiesFlow: React.FC = () => {
    return (<CustomerProjectTypesStatusesFlow projectTypeStatus={0}/>)
}

export default CustomerOpportunitiesFlow